import React, { useState, useEffect } from "react";
import { LineChart, Line, XAxis, Tooltip, ResponsiveContainer } from "recharts";
import AdminOverviewStyle from "../AdminStyles/AdminOverviewStyle.module.css"; // Import CSS file for styling
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import { FaUserCircle } from "react-icons/fa"; // Using FaUserCircle as the profile icon
import { Link } from "react-router-dom"; // Import Link if you're using React Router

const AdminOverview = ({}) => {
  const [Promoteurs, setPromoters] = useState([]);
  const [Revenue, setRevenue] = useState(null);
  const [Participants, setParticipants] = useState(null);
  const [EventsHosted, setEventsHosted] = useState(null);
  const [Stats, setStats] = useState([]);
  const [adminId, setAdminId] = useState(localStorage.getItem("adminId"));
  const [Events, setEvents] = useState([]);
  const [stripeConnected, setStripeConnected] = useState(false); // New state for Stripe connection
  const adminKey = "Bearer " + process.env.REACT_APP_ADMIN_KEY; // Make sure to have your admin key in your .env
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  console.log("yo here is the backend url", BACKEND_URL);
  console.log("Backend URL:", process.env.REACT_APP_BACKEND_URL);
  console.log("Environment Variables:", process.env);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMetric, setSelectedMetric] = useState("revenue");

  useEffect(() => {
    const fetchPromoters = async () => {
      setIsLoading(true);
      try {
        let token = localStorage.getItem("token");
        const response = await axios.get(
          `${BACKEND_URL}/admin/team/${adminId}`,
          {
            headers: {
              authorization: `Bearer ${token}`
            }
          }
        );
        if (response.status === 200) {
          setPromoters(response.data.promotersData);
        } else {
          console.error("Failed to fetch events");
        }
      } catch (error) {
        console.error("Error fetching admin events:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPromoters();
  }, [adminId, adminKey, BACKEND_URL]);

  useEffect(() => {
    const fetchAdminEvents = async () => {
      setIsLoading(true);
      try {
        let token = localStorage.getItem("token");
        const response = await axios.get(
          `${BACKEND_URL}/admin/getEvents/${adminId}`,
          {
            headers: {
              authorization: `Bearer ${token}`
            }
          }
        );
        if (response.status === 200) {
          setEvents(response.data.events); // Changed from promotersData to events
        } else {
          console.error("Failed to fetch events");
        }
      } catch (error) {
        console.error("Error fetching admin events:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAdminEvents();
  }, [adminId, adminKey, BACKEND_URL]);

  useEffect(() => {
    const fetchStats = async () => {
      setIsLoading(true);
      try {
        if (adminId) {
          let token = localStorage.getItem("token");
          const response = await axios.get(
            `${BACKEND_URL}/events/getallMyeventsstats/${adminId}`,
            {
              headers: {
                authorization: `Bearer ${token}`
              }
            }
          );
          if (response.status === 200) {
            const data = response.data;
            const totalRevenue = data.reduce(
              (acc, event) => acc + event.totalRevenue,
              0
            );
            const totalParticipants = data.reduce(
              (acc, event) => acc + event.numberOfParticipants,
              0
            );
            const totalEventsHosted = data.length;
            setRevenue(totalRevenue);
            setParticipants(totalParticipants);
            setEventsHosted(totalEventsHosted);
            const processedData = response.data.reduce((acc, event) => {
              const period = new Date(event.dateAndHour).toLocaleDateString(
                "default",
                {
                  day: "2-digit",
                  month: "short",
                  year: "numeric"
                }
              );
              if (!acc[period]) {
                acc[period] = { revenue: 0, participants: 0, scanned: 0 };
              }
              acc[period].revenue += event.totalRevenue;
              acc[period].participants += event.numberOfParticipants;
              acc[period].scanned += event.numberOfScannedTickets;
              return acc;
            }, {});

            // Convert to array and set to state
            const graphData = Object.entries(processedData).map(
              ([period, data]) => ({
                period,
                ...data
              })
            );

            setStats(graphData);
          } else {
            console.error("Failed to fetch events");
          }
        }
      } catch (error) {
        console.error("Error fetching admin events:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchStats();
  }, [adminId, adminKey, BACKEND_URL]);

  const username = localStorage.getItem("name");

  const BlocksComp = ({ title, value }) => {
    console.log("Lets have a look at the values : ", value, value === null);
    if (value.includes("null")) {
      return (
        <div className={AdminOverviewStyle.metricBlock}>
          <ClipLoader size={30} color={"#123abc"} loading={true} />{" "}
          {/* Loading Spinner */}
        </div>
      );
    }

    return (
      <div className={AdminOverviewStyle.metricBlock}>
        <span className={AdminOverviewStyle.numbers}>{value}</span>
        <span
          className={AdminOverviewStyle.textNumber}
          style={{
            // Adjust font size as needed
            color: "grey"
          }}
        >
          {title}
        </span>
      </div>
    );
  };
  const EventCard = ({ eventName, clubName, date, image }) => {
    const formattedDate = new Date(date).toLocaleDateString("en-US", {
      day: "numeric",
      month: "short"
    });

    return (
      <div className={AdminOverviewStyle.eventcard}>
        <img
          className={AdminOverviewStyle["event-image"]}
          src={image}
          alt={`${eventName}`}
        />
        <div className={AdminOverviewStyle["event-details"]}>
          <div className={AdminOverviewStyle["event-name"]}>{eventName}</div>
          <div className={AdminOverviewStyle["club-name"]}>{clubName}</div>
        </div>
        <div className={AdminOverviewStyle["event-date-box"]}>
          {formattedDate}
        </div>
      </div>
    );
  };
  const Promoter = ({ firstName, lastName, image }) => {
    return (
      <div
        style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}
      >
        <img
          src={image}
          alt={`${firstName} ${lastName}`}
          style={{
            borderRadius: "50%",
            marginRight: "10px",
            width: "40px",
            height: "40px",
            objectFit: "cover"
          }}
        />
        <span>{`${firstName} ${lastName}`}</span>
      </div>
    );
  };

  if (isLoading) return <div>Loading...</div>;
  return (
    <div className={AdminOverviewStyle.dashboard}>
      <div className={AdminOverviewStyle.header}>
        <h1>Hello {username}!</h1>
        <p>Welcome back!</p>
        <Link to="/user-profile" className={AdminOverviewStyle.profileLink}>
          <button className={AdminOverviewStyle.profileButton}>
            <FaUserCircle className={AdminOverviewStyle.profileIcon} /> My
            Profile
          </button>
        </Link>
      </div>
      <div className={AdminOverviewStyle.metrics}>
        <div className={AdminOverviewStyle["metric revenue"]}>
          <BlocksComp title="Revenue" value={`€${Revenue}`} />
        </div>
        <div className={AdminOverviewStyle["metric participants"]}>
          <BlocksComp title="Participants" value={`${Participants}`} />
        </div>
        <div className={AdminOverviewStyle["metric events-hosted"]}>
          <BlocksComp title="Events Hosted" value={`${EventsHosted}`} />
        </div>
      </div>
      <div className={AdminOverviewStyle.statistics}>
        <h2>Your statistics</h2>
        <div className={AdminOverviewStyle.statistics}>
          <h2>
            {selectedMetric.charAt(0).toUpperCase() + selectedMetric.slice(1)}{" "}
            This Month
          </h2>
          <div>
            <select
              value={selectedMetric}
              onChange={(e) => setSelectedMetric(e.target.value)}
            >
              <option value="revenue">Revenue</option>
              <option value="participants">Number of Participants</option>
              <option value="scanned">Number of Scanned</option>
            </select>
          </div>

          <div className={AdminOverviewStyle["chart-container"]}>
            {Stats.length > 0 ? (
              <ResponsiveContainer width="100%" height={300}>
                <LineChart data={Stats}>
                  <Line
                    type="monotone"
                    dataKey={selectedMetric}
                    stroke="#00338d"
                  />
                  <XAxis dataKey="period" />
                  <Tooltip />
                </LineChart>
              </ResponsiveContainer>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "300px"
                }}
              >
                <ClipLoader color={"#123abc"} size={50} />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className={AdminOverviewStyle["past-events"]}>
        <h2>Past Events</h2>
        {/* Map over your Events data to create this list */}
        {Events.map((event) => (
          <EventCard
            key={event.id}
            eventName={event.eventName}
            clubName={event.club.name}
            date={event.dateAndHour}
            image={event.image}
            exclusivityDescription={event.exclusivity_description}
          />
        ))}
      </div>

      <div className={AdminOverviewStyle["promoters"]}>
        <h2>Promoters</h2>
        {/* Similarly, map over promoters */}
        <div>
          {Promoteurs.map((promoter, index) => (
            <Promoter
              key={promoter.id}
              image={promoter.image}
              firstName={promoter.firstName}
              lastName={promoter.lastName}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminOverview;
